import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useEffect, useState } from "react";
import {
  assignStock,
  createCategory,
  deleteStock,
  getStockList,
  updateCategory,
  updateStock,
} from "../../../../services/workspace/inventory.service";
import { useNavigate } from "react-router-dom";
import CommonForm from "../../../components/form/form";
import CommonModal from "../../../components/modals/commonModel";
import { fetchStaffList } from "../../../../store/slices/user.slice";
import { useDispatch, useSelector } from "react-redux";

const actions_type = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  DELETE: "DELETE",
  ASSIGN: "ASSIGN",
  CLEAR: "CLEAR",
  EXPIRE: "EXPIRE",
};

const items = [{ label: "Stock", path: "" }];

const ManageStock = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [selectedId, setSelectedId] = useState(false);
  const { staffList, staffLoading } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStaffList());
  }, [dispatch]);

  const staffOptions =
    staffList?.user?.data?.map((user) => ({
      label: user?.name,
      value: user?.id,
    })) || [];

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getStockList, {
    dataPath: "stock.data",
    totalPath: "stock.meta.total",
    errorMessage: "Failed to fetch category data!",
    debounceDelay: 500,
    customParams: {
      with: "category",
    },
    // Dynamic sorting configuration
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "stock",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Add data transformer function
    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "link",
            link:`/inventory/stock/detail/${item.uuid}`
          },
          name: {
            data: item?.name,
            className: "",
            sticky: false,
            variant: "link",
            link:`/inventory/stock/detail/${item.uuid}`
          },
          category: {
            data: item.category.name,
            className: "",
            sticky: false,
            variant: "text",
          },
          quantity: {
            data: item.quantity || "0",
            className: "",
            sticky: false,
            variant: "text",
          },
          stock_type: {
            data: item.stock_type === 0 ? "Consumable" : "Fixed",
            className: "",
            sticky: false,
            variant: "text",
          },
          createdAt: {
            data: item.created_at,
            className: "",
            sticky: false,
            variant: "date-time",
          },

          status: {
            data: item.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: null,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = {
          view: (item) => {
            navigate(`/inventory/stock/detail/${item.uuid.data}`, {});
          },
          edit: (item) => {
            navigate(`/inventory/stock/edit/${item.uuid.data}`, {});
          },
          delete: (item) => {
            handleDelete(item.uuid.data, deleteStock, {
              successMessage: "Stock deleted successfully!",
              errorMessage: "Failed to delete stock!",
            });
          },

          assign: (item) => {
            openModal(item, actions_type.ASSIGN);
            setIsEditValue({
              uuid: item.uuid.data,
              id: item.id.data,
              name: item.name.data, 
              quantity: item.quantity.data, 
            });
          },
          clear: (item) => {
            handleUpdate({ clear_stock: 1 }, item.uuid.data, updateStock, {
              successMessage: "Stock Clear successfully!",
              errorMessage: "Failed to clear stock!",
            });
          },
          expire: (item) => {
            openModal(item, actions_type.EXPIRE);
            setIsEditValue({
              uuid: item.uuid.data,
              id: item.id.data,
              expired_stock: item,
              quantity: item.quantity.data,
            });
          },
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    {
      label: "Product ID",
      key: "code",
    },
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Category",
      key: "category",
    },
    {
      label: "Quantity",
      key: "quantity",
    },
    {
      label: "Stock Type",
      key: "stock_type",
    },
    {
      label: "Created At",
      key: "createdAt",
    },
  ];

  // Comprehensive form fields
  const comprehensiveFields = [
    // Basic text fields
    {
      name: "user_id",
      label: "Assign User",
      type: "select",
      placeholder: "Enter category name",
      // required: true,
      options: staffOptions,
      colSpan: 6,
      minLength: 2,
      maxLength: 40,
    },
    {
      name: "quantity",
      label: "Quantity",
      type: "number",
      placeholder: "Enter category name",
      required: true,
      colSpan: 6,
      minLength: 2,
      maxLength: 40,
    },

    // Textarea
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Write description here...",
      maxLength: 300,
      colSpan: 12,
    },
  ];

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        ...values,
      };

      await handleCreate(payload, assignStock, {
        successMessage: "Stock assigned successfully!",
        errorMessage: "Failed to assign stock!",
      });
    } finally {
      setSubmitting(false);
      setTimeout(() => resetForm(), 1000);
    }
  };
  const handleExpire = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        ...values,
        stock_id: isEditValue?.id, // ensure linking to stock
      };

      const response = await handleUpdate(
        payload,
        isEditValue.uuid,
        updateStock,
        {
          successMessage: "Stock expired successfully!",
          errorMessage: "Failed to expire stock!",
        }
      );

      if (response.success) {
        resetForm();
        closeModal();
        fetchData(); // refresh table
      }
    } catch (error) {
      console.error("Error expiring stock:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const onClose = (reload = false) => {
    setSelectedId("");
    openModal(false);
    if (reload === true) {
      fetchData();
    }
  };

  const expireFields = [
    
    {
      name: "quantity",
      label: "Total Quantity",
      type: "number",
      colSpan: 6,
      minLength: 2,
      maxLength: 40,
      readOnly:true
      
    },
    {
      name: "expired_stock",
      label: "Expired Quantity",
      type: "number",
      placeholder: "Enter expired stock quantity",
      required: true,
      colSpan: 6,
      minLength: 2,
      maxLength: 40,
    },
  ];

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        // onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        onClickAdd={() => navigate("/inventory/stock/add", actions_type.ADD)}
        shorting
        sortingModule="stock"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />
        {action === actions_type.ASSIGN && (
          <CommonModal
            modalSize="lg"
            headerTitle={selectedId ? "Edit Assign Stock" : "Assign Stock"}
            onClose={onClose}
            show={action === actions_type.ASSIGN}
          >
            {/* Form */}
            <CommonForm
              fields={comprehensiveFields}
              // initialData={testMode === "edit" ? testInitialData : {}}
              initialData={isEditValue ? isEditValue : {}}
              onSubmit={handleSubmit}
              submitButtonText={
                "Submit"
                // testMode === "create" ? "Create User" : "Update User"
              }
              columnsPerRow={1}
              gap="gap-4"
              rowClassName="   "
              fieldClassName="bg-white p-3 rounded shadow-sm"
            />
          </CommonModal>
        )}
      </div>
      {action === actions_type.EXPIRE && (
        <CommonModal
          modalSize="md"
          headerTitle="Expire Stock"
          onClose={onClose}
          show={action === actions_type.EXPIRE}
        >
          <CommonForm
            fields={expireFields}
            initialData={isEditValue ? isEditValue : {}}
            onSubmit={handleExpire}
            submitButtonText="Expire Stock"
            columnsPerRow={1}
            gap="gap-4"
            fieldClassName="bg-white p-3 rounded shadow-sm"
          />
        </CommonModal>
      )}
    </div>
  );
};
export default ManageStock;
